import React from 'react';
import { Text } from '@cuemath/web-comps';

import {
  RequestDetailTitle,
  RequestDetailsCard,
  RequestDetailsContainer,
  STOverallInfoContainer,
  TotalRequestCard,
} from './styles/overall-info';

const STOverallInfo = ({ requestCounts }) => {
  const {
    searching_for_teacher_count: searchingForTeacherCount,
    teacher_not_found_count: teacherNotFoundCount,
    teacher_found_count: teacherFoundCount,
    first_class_done_count: firstClassDoneCount,
    second_class_done_count: secondClassDoneCount,
    transfer_successful_count: transferSuccessCount,
    total_counts: totalRequestCount,
  } = requestCounts || {};

  const showDefaultValue =
    !searchingForTeacherCount &&
    !teacherNotFoundCount &&
    !teacherFoundCount &&
    !firstClassDoneCount &&
    !secondClassDoneCount &&
    !transferSuccessCount &&
    !totalRequestCount;

  const rederingData = [
    {
      title: 'Searching for teacher',
      value: searchingForTeacherCount,
    },
    {
      title: 'Teacher not found',
      value: teacherNotFoundCount,
    },
    {
      title: 'Teacher found',
      value: teacherFoundCount,
    },
    {
      title: '1st class done',
      value: firstClassDoneCount,
    },
    {
      title: '2nd class done',
      value: secondClassDoneCount,
    },
    {
      title: 'Transfer successful',
      value: transferSuccessCount,
    },
  ];

  return (
    <STOverallInfoContainer justifyContent="space-between" alignItems="center" nowrap>
      <TotalRequestCard alignItems="center" nowrap>
        <Text variant="cta2">Total requests</Text>
        <Text variant="h3">{showDefaultValue ? '-' : totalRequestCount}</Text>
      </TotalRequestCard>

      <RequestDetailsContainer nowrap justifyContent="center" alignItems="center">
        {rederingData.map(({ title, value }) => (
          <RequestDetailsCard alignItems="center" key={title} nowrap>
            <RequestDetailTitle variant="body31">{title}</RequestDetailTitle>
            <Text variant="h4">{showDefaultValue ? '-' : value}</Text>
          </RequestDetailsCard>
        ))}
      </RequestDetailsContainer>
    </STOverallInfoContainer>
  );
};

export default STOverallInfo;
